"use strict";

import "./VehicleBubble.css";
import zIndex from "./../zIndex";
import Bubble from "./../Bubble";

const MAX_WIDTH = 200;

/**
	@param {Object} params
		@param {google.maps.Map} params.map
		@param {google.maps.LatLng} params.position
		@param {Boolean} params.visible
		@param {String} params.name
		@param {String} params.movingState
		@param {Boolean} params.selected
		@param {Number} [zIndex]
		@param {Function} [params.onClick=(alt => {})]
*/

const COLORS = {
	default:		"white",
	onIgnition:		"#FFB300",
	moving:			"#8BC34A",
	selected:		"#797979"
};

export default class VehicleBubble extends Bubble {
	
	constructor(params) {
		
		params = params || {};
		
		const content = document.createElement("div");
		
		super({
			map: params.map,
			position: params.position,
			content: content,
			maxWidth: MAX_WIDTH,
			zIndex: params.zIndex || zIndex.IGNITION_OFF
		});
		
		this.wrapper.classList.add("VehicleBubble");
		
		if (params.onClick)
			content.addEventListener('click', evt => params.onClick(evt.altKey?true:false));
		
		this.createLabel(content);
		
		this.lastMovingState = "";
		
		this.update(params);
	}
	
	createLabel(parent) {
		this.label = document.createElement("label");
		parent.appendChild(this.label);
	}
	
	/**
		@param {Object} params
			@param {google.maps.LatLng} params.position
			@param {Boolean} params.visible
			@param {String} params.name
			@param {String} params.movingState
			@param {Boolean} params.selected
			@param {Number} params.zIndex
	*/
	
	update(params) {
		if (params.position !== undefined)
			this.setPosition(params.position);
		if (params.visible !== undefined)
			this.setVisible(params.visible);
		if (params.name !== undefined) {
			this.label.textContent = params.name;
			this.refresh();
		}
		if (params.selected !== undefined || params.movingState !== undefined) {
			if (params.movingState !== undefined)
				this.lastMovingState = params.movingState;
			const colorMode = params.selected ? "selected" : (params.movingState || this.lastMovingState);
			this.setColor(COLORS[colorMode], colorMode=="selected"?"white":null);
		}
		if (params.zIndex !== undefined) {
			this.setZIndex(params.zIndex);
		}
	}
}


// WEBPACK FOOTER //
// ./src/view/Map/VehicleBubble/VehicleBubble.js